import i18next from 'i18next'

export const loadTranslations = async (locale: string): Promise<void> => {
  const translationBackendUrl = process.env.REACT_APP_TRANSLATION_BACKEND_URL
  await fetch(`${translationBackendUrl}locales/${locale}.json`)
    .then((response) => response.json())
    .then((translations) => i18next.addResources(locale, 'translation', translations))
}

export const getCookie = (name: string): string | null => {
  const matches = document.cookie.match(
    // eslint-disable-next-line no-useless-escape
    new RegExp(`(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`),
  )
  return matches ? decodeURIComponent(matches[1]) : null
}

export const generateParams = (params: Record<string, string | undefined>): string => {
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => value && searchParams.append(key, value.toString()))
  return `${searchParams.toString()}`
}
